import { RouteMetadata } from './types';

export const skillsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/skills/:skillId/file/:fileId',
        section: 'skills',
        view: 'file-editor',
        descriptionTemplate: 'User is editing file {fileId} within skill {skillId}',
        capabilities: [
            'Edit skill instructions and reference resources',
            'Navigate between entrypoint and resource files',
            'Publish, deprecate, or remove the skill',
            'Open version history and compare prior releases',
            'Update skill metadata and references',
        ],
        hints: [
            'Skill editing happens in a file-based workspace',
            'The entrypoint file controls the core behavior of the skill',
            'Referenced resources can provide additional context and instructions',
            'Published skills can be restored from version snapshots',
        ],
    },
    {
        pattern: '/agents/:agentId/skills/:skillId/versions/:versionId',
        section: 'skills',
        view: 'version-viewer',
        descriptionTemplate: 'User is viewing version {versionId} for skill {skillId}',
        capabilities: [
            'Inspect the published snapshot in read-only mode',
            'Review entrypoint and resource file contents',
            'Fork the selected version into a new draft',
            'Compare historical behavior before restoring',
        ],
        hints: [
            'Version viewer is read-only and cannot edit files directly',
            'Forking creates or overwrites a working draft for edits',
            'Published versions preserve both instructions and resources',
        ],
    },
    {
        pattern: '/agents/:agentId/skills/:skillId',
        section: 'skills',
        view: 'editor',
        descriptionTemplate: 'User is viewing skill editor for skill {skillId}',
        capabilities: [
            'Open the skill workspace and navigate files',
            'Review status, source, and publish state',
            'Manage references and resource files',
            'Access publish and version history flows',
        ],
        hints: [
            'The editor route typically redirects to the entrypoint file',
            'Skill status controls which actions are currently available',
            'System and org skills can have different edit permissions',
        ],
    },
    {
        pattern: '/agents/:agentId/skills',
        section: 'skills',
        view: 'list',
        descriptionTemplate: 'User is viewing the skills list',
        capabilities: [
            'Browse skills by source and type filters',
            'Search skills semantically by query',
            'Open skill editors and version history',
            'Create new skills',
        ],
        hints: [
            'Skills can be local to an organization or globally managed',
            'Search and list modes may return different relevance ordering',
            'Type and source filters are encoded in URL search params',
        ],
    },
];
